module.exports = __webpack_public_path__ + "img/saveMarks.7b5338fc.svg";